module.exports = __webpack_public_path__ + "success-point.png?b657a9093f6ca3e7cd99203ecdefcba9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confirm-point/success-point.png
// module id = 1095
// module chunks = 0